import React from 'react';
import Button from '../ui/Button';

interface Props {
  resetErrorBoundary: () => void;
}

const PageCrashFallback: React.FC<Props> = ({ resetErrorBoundary }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full bg-white p-6 rounded-lg shadow-md text-center">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">Ett oväntat fel har uppstått</h2>
        <p className="text-gray-600 mb-6">
          Sidan kunde inte laddas korrekt. Försök att ladda om eller kontakta support om problemet kvarstår.
        </p>
        <div className="flex gap-4 justify-center">
          <Button onClick={resetErrorBoundary} variant="primary">
            Försök igen
          </Button>
          <Button onClick={() => window.location.reload()} variant="secondary">
            Ladda om hela sidan
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PageCrashFallback;